/**
 * Pendant l'offre partenaire, le workspace n'a pas d'abonnement Stripe (`NONE`) mais le back lui
 * accorde le forfait Enterprise : seul l'usage renvoyé par le back le distingue d'un compte gratuit.
 */
export function isPartnerOfferPlan(
  subscriptionStatus: string | null | undefined,
  usagePlanName: string | null | undefined,
): boolean {
  return subscriptionStatus === 'NONE' && usagePlanName === 'Enterprise';
}

/** La limite de 10 inscrits par webinaire ne vise que les comptes gratuits, pas l'offre partenaire. */
export function hasFreeRegistrationLimit(
  subscriptionStatus: string | null | undefined,
  usagePlanName: string | null | undefined,
): boolean {
  return subscriptionStatus === 'NONE' && !isPartnerOfferPlan(subscriptionStatus, usagePlanName);
}
